export default __webpack_public_path__ + "static/media/1345.ca9a5199.png";